// extracted by mini-css-extract-plugin
module.exports = {"standardTabButton":"standardTabButton__FVyUk","standardTabPanel":"standardTabPanel__PjFHa","standardTabSlider":"standardTabSlider__hY71z"};